export const typeformPopupData = {
  tfPopup: 'xBrHREIQ',
  tfProps: 'title=Request New NFT Creation',
  tfMedium: 'snippet'
}

export const NFT_DETAILS = {
  SYMBOL: 'NFT'
}

export const NFT_MEDIA_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio'
}
